export default "__VITE_ASSET__CFrqth_z__"